module.exports = __webpack_public_path__ + "img/aiot_block3.dd5489d0.png";